import * as React from "react"

function SvgComponent() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="prefix__feather prefix__feather-x"
    >
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  )
}

export default SvgComponent
